module.exports = __webpack_public_path__ + "static/media/e-doctor uses curoflow telemedicine platform.34d43807.webp";